export const MEDIA_KEYS = Object.freeze({
  arenaCelestialFloor: 'game.arena.celestial.floor',
  arenaVisualGeometry: 'game.arena.visual.soccar-boundary',
  ballDefault: 'game.ball.default',
  vehicleOctane: 'game.vehicles.octane',
  goalMagicPortalModel: 'game.effects.goal-explosions.magic-portal.model',
  goalMagicPortalImpact: 'game.effects.goal-explosions.magic-portal.impact',
  arenaCelestialWind: 'game.audio.arena-themes.celestial.background-wind',
  boostPickupLarge: 'game.audio.sfx.boost-pickup.large',
  boostPickupSmall: 'game.audio.sfx.boost-pickup.small',
  demolition: 'game.audio.sfx.demolition',
  engineIdle: 'game.audio.sfx.engine.idle',
  boostStart: 'game.audio.sfx.boost.start',
  boostLoop: 'game.audio.sfx.boost.loop',
  boostRelease: 'game.audio.sfx.boost.release',
  flipReset: 'game.audio.sfx.flip-reset',
  supersonicLoop: 'game.audio.sfx.supersonic.loop',
  chatSend: 'chat.audio.send',
  chatReceive: 'chat.audio.receive',
} as const);

export type MediaKey = typeof MEDIA_KEYS[keyof typeof MEDIA_KEYS];

export function mediaAssetUrl(key: string): string {
  return `/api/media/assets/${encodeURIComponent(key)}`;
}

export function mediaRevisionUrl(revisionId: string): string {
  return `/api/media/revisions/${encodeURIComponent(revisionId)}`;
}
